///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportReferralType = Meevo.Plugins.Reports.IReportReferralType;


    export class ReportReferralTypesCollection extends SmartMoverApiCollection<IReportReferralType> implements IApiCollection<IReportReferralType> {

        protected get url() {
            return 'report/ReferralType';
        }
    }

}